export const UnsupportedBrowser = ()=> {

    return (
        <div>
            <strong>
            Unfortunately this browser is not supported. Please reopen the site in a supported browser such as Chrome, Firefox or Edge.
            </strong>
        </div>
    )
}